import React, { Component } from 'react'
import { Default, Mobile, isTablet, isNarrowDesktop } from '../../media-queries'
import InfoBlock from '../shared/infoBlock'
import AngleBracket from '../shared/angleBracket'
import Step from './step'
import AngleBracketButton from '../shared/angleBracketButton'
import Collapsable from '../shared/collapsable'

export default class ApplicationProcedure extends Component {
  render() {
    return (
      <div>
        <Default>
          <DefaultApplicationProcedure {...this.props} />
        </Default>
        <Mobile>
          <MobileApplicationProcedure {...this.props} />
        </Mobile>
      </div>
    )
  }
}

const DefaultApplicationProcedure = props => (
  <div
    style={{
      display: 'flex',
    }}
  >
    <div
      style={{
        background: '#F7F7F7',
        minHeight: props.height,
        padding: isTablet()
          ? '2rem 4rem 3rem'
          : `2rem ${isNarrowDesktop() ? '5rem' : '7rem'} 2rem 5rem`,
        width: '58vw',
      }}
    >
      <InfoBlock
        title={props.header.title}
        bigTitle={true}
        extra={props.header.titleAccent}
        accentColor={'#8CBD8C'}
        text={props.header.text.internal.content}
      />
    </div>
    <SideContent {...props} />
  </div>
)

const MobileApplicationProcedure = props => (
  <div
    style={{
      background: '#8CBD8C',
    }}
  >
    <InfoBlock
      title={props.header.title}
      extra={props.header.titleAccent}
      text={props.header.text.internal.content}
      style={{ padding: '1rem 2rem' }}
    />
    <div style={{ margin: '0 3rem', paddingBottom: '1rem' }}>
      <Step {...props.step} />
    </div>
    <div style={{ margin: '1rem 2rem' }}>
      <AngleBracketButton
        text={props.eConsortLink.displayName}
        newTab={true}
        link={props.eConsortLink.url}
      />
      <div
        style={{
          margin: '1rem',
          fontStyle: 'italic',
          fontSize: 12,
        }}
      >
        {props.registrationText}
      </div>
      <Collapsable
        isCollapsed={true}
        text={props.registeredButtonText}
        backgroundColor={'white'}
      >
        <div
          style={{
            margin: '1rem',
            fontStyle: 'italic',
            fontSize: 12,
          }}
        >
          {props.applicationText}
        </div>
        <a
          href={props.applicationFormLink.url}
          target={'_blank'}
          style={{
            margin: '1rem 0',
            border: '3px solid white',
            padding: '1.5em',
            textAlign: 'center',
            color: 'black',
            fontSize: 18,
            fontWeight: 600,
            background: 'white',
            cursor: 'pointer',
            display: 'block',
          }}
          className={'unselectable card'}
        >
          {props.applicationFormLink.displayName}
        </a>
      </Collapsable>
    </div>
    <div
      style={{
        padding: '2rem 2rem 3rem',
        fontSize: 14,
        fontWeight: 600,
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
      }}
    >
      <div onClick={props.previousStep} style={{ cursor: 'pointer' }}>
        <AngleBracket
          color={'black'}
          style={{
            width: 5,
            transform: 'scaleX(-1)',
            filter: 'FlipH',
          }}
        />
        <span>&nbsp;&nbsp;Back</span>
      </div>
    </div>
  </div>
)

const SideContent = props => (
  <div
    style={{
      background: '#8CBD8C',
      minHeight: props.height,
      padding: `15vh ${isNarrowDesktop() ? '8vw' : '12.5vw'} 1rem ${
        isNarrowDesktop() ? '1rem' : '3rem'
      }`,
      width: '42vw',
    }}
  >
    <div style={{ marginBottom: '3rem' }}>
      <Step {...props.step} />
    </div>
    <AngleBracketButton
      text={props.eConsortLink.displayName}
      newTab={true}
      link={props.eConsortLink.url}
    />
    <div
      style={{
        margin: '1rem 0',
        fontStyle: 'italic',
        fontSize: 12,
      }}
    >
      {props.registrationText}
    </div>
    <Collapsable
      isCollapsed={true}
      text={props.registeredButtonText}
      backgroundColor={'white'}
    >
      <div
        style={{
          margin: '1rem 0',
          fontStyle: 'italic',
          fontSize: 12,
        }}
      >
        {props.applicationText}
      </div>
      <a
        href={props.applicationFormLink.url}
        target={'_blank'}
        style={{
          padding: '2em',
          textAlign: 'center',
          color: 'black',
          fontSize: 18,
          fontWeight: 600,
          background: 'white',
          cursor: 'pointer',
          display: 'block',
        }}
        className={'unselectable card'}
      >
        {props.applicationFormLink.displayName}
      </a>
    </Collapsable>
    <div
      style={{
        fontSize: 14,
        fontWeight: 600,
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
        margin: '3rem 0',
      }}
    >
      <div onClick={props.previousStep} style={{ cursor: 'pointer' }}>
        <AngleBracket
          color={'black'}
          style={{
            width: 5,
            transform: 'scaleX(-1)',
            filter: 'FlipH',
          }}
        />
        <span>&nbsp;&nbsp;Back</span>
      </div>
    </div>
  </div>
)



// WEBPACK FOOTER //
// ./src/components/application/applicationProcedure.js